import React, { useEffect, createElement } from 'react';
import { Landing } from './pages/Landing';
const META_PIXEL_ID = '25855226074068949';
const PAGE_TITLE = 'MIS PRIMERAS LECTURAS — De las sílabas a sus primeras palabras';
const PAGE_DESC = 'Para padres de niños de 4 a 7 años que reconocen letras pero todavía no logran leer palabras completas. 100% PDF, acceso inmediato.';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/1Lg8boNxXxBLRjQZaKz5Hb/ChatGPT_Image_14_jun_2026,_02_49_33.webp';
const SITE_URL = 'https://www.tupuntodigital.shop';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function addLink(rel: string, href: string, attrs: Record<string, string> = {}) {
  const selector = `link[rel="${rel}"][href="${href}"]`;
  if (document.head.querySelector(selector)) return;
  const el = document.createElement('link');
  el.rel = rel;
  el.href = href;
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
}
export function App() {
  // SEO: title, meta description, lang, social/OG tags, structured data
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.lang = 'es-AR';
    document.title = PAGE_TITLE;
    // Performance: warm up critical origins and preload the LCP hero image
    addLink('preconnect', 'https://cdn.magicpatterns.com', {
      crossorigin: ''
    });
    addLink('preconnect', 'https://fonts.googleapis.com');
    addLink('preconnect', 'https://fonts.gstatic.com', {
      crossorigin: ''
    });
    addLink('preload', HERO_IMAGE, {
      as: 'image',
      fetchpriority: 'high'
    });
    addLink('canonical', SITE_URL);
    setMeta('name', 'description', PAGE_DESC);
    setMeta('name', 'viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');
    setMeta('name', 'theme-color', '#1e293b');
    setMeta('name', 'robots', 'index, follow');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESC);
    setMeta('property', 'og:locale', 'es_AR');
    setMeta('property', 'og:image', HERO_IMAGE);
    setMeta('property', 'og:url', SITE_URL);
    setMeta('property', 'og:site_name', 'Mis Primeras Lecturas');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:image', HERO_IMAGE);
    setMeta('name', 'twitter:title', PAGE_TITLE);
    setMeta('name', 'twitter:description', PAGE_DESC);
    // Structured data (Product) for richer SEO
    const ldId = 'ld-product-schema';
    if (!document.getElementById(ldId)) {
      const ld = document.createElement('script');
      ld.id = ldId;
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'MIS PRIMERAS LECTURAS',
        description: PAGE_DESC,
        image: HERO_IMAGE,
        brand: {
          '@type': 'Brand',
          name: 'Tu Punto Digital'
        },
        offers: {
          '@type': 'Offer',
          price: '14990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://www.tupuntodigital.shop/cart/46116455907501:1'
        }
      });
      document.head.appendChild(ld);
    }
  }, []);
  // Meta Pixel — deferred until the browser is idle so it never blocks the
  // initial render / LCP (keeps performance score high). Loads on the
  // published domain (Pixel Helper only detects it there, not in the preview).
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const loadPixel = () => {
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'PageView');
        return;
      }
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      target.appendChild(script);
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
      // <noscript> fallback so the pixel still counts the view without JS
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.alt = '';
      img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      target.appendChild(noscript);
    };
    const ric = (window as any).requestIdleCallback as ((cb: () => void, opts?: {
      timeout: number;
    }) => number) | undefined;
    if (ric) {
      ric(loadPixel, {
        timeout: 4000
      });
    } else {
      const t = setTimeout(loadPixel, 2500);
      return () => clearTimeout(t);
    }
  }, []);
  return <Landing data-id="element-0" />;
}